import Print from "./print";

export default {
  print: (params, printFrame) => {
    params.printableElement = params.printable;

    Print.send(params, printFrame);
  },
};
